export const ADD_COURSE_REQUEST = "ADD_COURSE_REQUEST";
export const ADD_COURSE_SUCCESS = "ADD_COURSE_SUCCESS";
export const ADD_COURSE_FAILURE = "ADD_COURSE_FAILURE";

export const GET_COURSES_REQUEST = "GET_COURSES_REQUEST";
export const GET_COURSES_SUCCESS = "GET_COURSES_SUCCESS";
export const GET_COURSES_FAILURE = "GET_COURSES_FAILURE";

export const GET_MY_COURSES_REQUEST = "GET_MY_COURSES_REQUEST";
export const GET_MY_COURSES_SUCCESS = "GET_MY_COURSES_SUCCESS";
export const GET_MY_COURSES_FAILURE = "GET_MY_COURSES_FAILURE";

export const GET_COURSE_NESTED_DETAIL_REQUEST =
  "GET_COURSE_NESTED_DETAIL_REQUEST";
export const GET_COURSE_NESTED_DETAIL_SUCCESS =
  "GET_COURSE_NESTED_DETAIL_SUCCESS";
export const GET_COURSE_NESTED_DETAIL_FAILURE =
  "GET_COURSE_NESTED_DETAIL_FAILURE";

export const UPDATE_COURSE_APPROVAL_STATUS_REQUEST =
  "UPDATE_COURSE_APPROVAL_STATUS_REQUEST";
export const UPDATE_COURSE_APPROVAL_STATUS_SUCCESS =
  "UPDATE_COURSE_APPROVAL_STATUS_SUCCESS";
export const UPDATE_COURSE_APPROVAL_STATUS_FAILURE =
  "UPDATE_COURSE_APPROVAL_STATUS_FAILURE";

export const RESET_COURSE_APPROVAL_STATUS = "RESET_COURSE_APPROVAL_STATUS";

export const GET_COMPLETE_COURSE_DETAIL_REQUEST =
  "GET_COMPLETE_COURSE_DETAIL_REQUEST";
export const GET_COMPLETE_COURSE_DETAIL_SUCCESS =
  "GET_COMPLETE_COURSE_DETAIL_SUCCESS";
export const GET_COMPLETE_COURSE_DETAIL_FAILURE =
  "GET_COMPLETE_COURSE_DETAIL_FAILURE";

export const GET_COURSE_BY_ID_REQUEST = "GET_COURSE_BY_ID_REQUEST";
export const GET_COURSE_BY_ID_SUCCESS = "GET_COURSE_BY_ID_SUCCESS";
export const GET_COURSE_BY_ID_FAILURE = "GET_COURSE_BY_ID_FAILURE";

export const GET_MY_LEARNING_REQUEST = "GET_MY_LEARNING_REQUEST";
export const GET_MY_LEARNING_SUCCESS = "GET_MY_LEARNING_SUCCESS";
export const GET_MY_LEARNING_FAILURE = "GET_MY_LEARNING_FAILURE";

export const GET_BASIC_COURSE_DETAIL_REQUEST = "GET_BASIC_COURSE_DETAIL_REQUEST";
export const GET_BASIC_COURSE_DETAIL_SUCCESS = "GET_BASIC_COURSE_DETAIL_SUCCESS";
export const GET_BASIC_COURSE_DETAIL_FAILURE = "GET_BASIC_COURSE_DETAIL_FAILURE";

export const UPDATE_COURSE_REQUEST = "UPDATE_COURSE_REQUEST";
export const UPDATE_COURSE_SUCCESS = "UPDATE_COURSE_SUCCESS";
export const UPDATE_COURSE_FAILURE = "UPDATE_COURSE_FAILURE";

export const SEARCH_APPROVED_COURSES_REQUEST = "SEARCH_APPROVED_COURSES_REQUEST";
export const SEARCH_APPROVED_COURSES_SUCCESS = "SEARCH_APPROVED_COURSES_SUCCESS";
export const SEARCH_APPROVED_COURSES_FAILURE = "SEARCH_APPROVED_COURSES_FAILURE";

export const GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST = "GET_PUBLIC_COURSE_COMPLETE_DETAIL_REQUEST";
export const GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS = "GET_PUBLIC_COURSE_COMPLETE_DETAIL_SUCCESS";
export const GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE = "GET_PUBLIC_COURSE_COMPLETE_DETAIL_FAILURE";
